export default __webpack_public_path__ + "static/media/bg-none.1be9a4c0.png";